module.exports = __webpack_public_path__ + "img/sceneIcon3-4.f3131bab.png";